import React, { useContext } from 'react';

import { useCard } from '@/react-query/hooks/query/use-card';

import { SessionContext } from '@components/app/Session';
import { CardService, CreditCardService } from '@domain/card';
import { useCheckIfGoogleWalletAvailable } from '@domain/digital-wallet/hooks';
import { CreditCard } from '@generated-types';
import { useUserIsHighFraudRisk } from '@hooks';

import { GooglePayButton } from './GooglePayButton';

import './GoogleWallet.scss';

type V4GoogleWallet = {
    card: CreditCard;
};

export const V4GoogleWallet = ({ card }: V4GoogleWallet) => {
    const isGoogleWalletAvailable = useCheckIfGoogleWalletAvailable();
    const IsHighFraudRisk = useUserIsHighFraudRisk();

    if (CreditCardService.isOwnerOfCard(card) && isGoogleWalletAvailable && !IsHighFraudRisk) {
        return (
            <div className="google-wallet">
                <GooglePayButton card={card} />
            </div>
        );
    }

    return null;
};

export const GoogleWallet = () => {
    const { data: card, isSuccess } = useCard();
    const session = useContext(SessionContext);
    const isGoogleWalletAvailable = useCheckIfGoogleWalletAvailable();
    const IsHighFraudRisk = useUserIsHighFraudRisk();

    if (!isSuccess) {
        return null;
    }

    if (CardService.isOwnerOfCard(card, session) && isGoogleWalletAvailable && !IsHighFraudRisk) {
        return (
            <div className="google-wallet">
                <GooglePayButton card={card} />
            </div>
        );
    }

    return null;
};
